<!-- <button type="button" class="mobile-nav-toggle d-lg-none" (click)="headerNav()"><i class="fa fa-bars"></i></button>
<div class="sidebar navbar-collapse" id="navbarCollapseSidebar" [ngClass]="status ? 'mobile-nav-active' : ''">
  <button type="button" class="mobile-nav-toggle d-lg-none" (click)="headerNav()"><i class="fa fa-close"></i></button>
  <div class="scroll-sidebar scroller">
    <div class="menu-section">
      <div class="top-head-sport">
        <div class="path-back"><i class="fa fa-ellipsis-v"></i></div>
        <ul class="text-right mr-2">
          <li><a>Sports</a></li>
        </ul>
      </div>
      <mat-accordion>
        <mat-expansion-panel class="no-submenu active">
          <mat-expansion-panel-header (click)="dashboard()">
            <a><span>Home</span></a>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
        <mat-expansion-panel *ngFor="let sports of allSportsList;let i= index">
          <mat-expansion-panel-header (click)="getSeriesList(sports.sport_id)">
            <a><span>{{sports.name}}</span></a>
          </mat-expansion-panel-header>
          <ul class="submenu-list">
            <li *ngFor="let series of allSeriesList;let j= index"
              (click)="goToDashboard(series)">
              <a> <span>{{series.name}}</span></a>
            </li>
          </ul>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <a><span>Reports</span></a>
          </mat-expansion-panel-header>
          <ul class="menu-list">
            <li><a class="dropdown-item" [routerLink]="['/myMarket']"><img src="assets/images/icon/my_market.png"> My
                Market</a></li>
            <li><a class="dropdown-item" [routerLink]="['/reports/openBets']"><img
                  src="assets/images/icon/open_bet.png"> Open Bets</a></li>
            <li><a class="dropdown-item" [routerLink]="['/reports/settledBets']"><img
                  src="assets/images/icon/settled_bet.png"> Settled Bets</a></li>
            <li><a class="dropdown-item" [routerLink]="['/reports/statements']"><img
                  src="assets/images/icon/statement.png"> Statements</a></li>
            <li><a class="dropdown-item" [routerLink]="['/reports/profitLoss']"><img
                  src="assets/images/icon/profit_loss.png"> Profit & Loss</a></li>
          </ul>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<div class="mobile-nav-overly" [ngClass]="status ? 'mobile-nav-block' : ''"></div> -->


<div class="sidebar-inner">
  <div _ngcontent-vuu-c83="" class="deposit-withdraw-sidebar-title deposit"><a _ngcontent-vuu-c83=""  style="color: initial;" routerLink="/deposit"><h5 _ngcontent-vuu-c83="" class="d-inline-block m-b-0"><img _ngcontent-vuu-c83="" src="assets/img/deposit.webp"> Deposit</h5></a></div>
  <div _ngcontent-vuu-c83="" class="deposit-withdraw-sidebar-title withdraw"><a _ngcontent-vuu-c83=""  style="color: initial;"routerLink="/withdraw"><h5 _ngcontent-vuu-c83="" class="d-inline-block m-b-0"><img _ngcontent-vuu-c83="" src="assets/img/withdraw.webp"> Withdraw</h5></a></div>
  <div data-toggle="collapse" data-target="#casino" class="sidebar-title" aria-expanded="false" aria-controls="casino">
    <h5 class="d-inline-block m-b-0">Others</h5>
  </div>
  <nav id="casino" class="casino collapse show">
    <ul >
    
     <li class="nav-item">
        <a class="nav-link" routerLink="/casino-detail/150036/DC">
          <span class="new-launch-text">Live Casino</span>
        </a>
      </li> 
      <li class="nav-item">
        <a class="nav-link" routerLink="/casino-detail/900010/DC">
          <span class="new-launch-text">World Matka</span>
        </a>
      </li> 
      <li class="nav-item">
        <a class="nav-link" routerLink="/casino-detail/150002/DC">
          <span class="new-launch-text">BACCARAT </span>
        </a>
      </li> 
      <li class="nav-item">
        <a class="nav-link" routerLink="/casino-detail/150041/DC">
          <span class="new-launch-text">Poker</span>
        </a>
      </li> 
      <li class="nav-item">
        <a class="nav-link" routerLink="/casino-detail/hi-lo/SPB">
          <span class="new-launch-text">    Hi Low</span>
        </a>
      </li> 

      <li class="nav-item">
        <a class="nav-link" routerLink="/casino-detail/901007/DC">
          <span class="new-launch-text"> Amar Akbar Anthony</span>
        </a>
      </li> 

      <li class="nav-item">
        <a class="nav-link" routerLink="/casino-detail/400066/DC">
          <span class="new-launch-text"> Roulette</span>
        </a>
      </li> 

      <li class="nav-item">
        <a class="nav-link" routerLink="/casino-detail/600087/DC">
          <span class="new-launch-text">Dragon Tiger</span>
        </a>
      </li> 

      <li class="nav-item">
        <a class="nav-link" routerLink="/casino-detail/150006/DC">
          <span class="new-launch-text">Lukcy 7</span>
        </a>
      </li> 

      <li class="nav-item">
        <a class="nav-link" routerLink="/casino-detail/900011/DC">
          <span class="new-launch-text">Bollywood Casino </span>
        </a>
      </li> 
    </ul>
  </nav>
  <div id="events" class="sidebar-title m-t-0 theme2bg" aria-controls="events" aria-expanded="true" role="button">
    <h5 class="text-white d-inline-block m-b-0">All Sports</h5>
  </div>
  <div class="mtree-main collapse show">
    <div class="ps">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let sports of allSportsList;let i= index" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header (click)="getSeriesList(sports.sport_id)">
            <span class="expand-icon" *ngIf="panelOpenState"></span>
                 <span class="expand-icon" *ngIf="!panelOpenState"></span>
            <a><span>{{sports.name}}</span></a>
          </mat-expansion-panel-header>
          <mat-accordion>
          <ul class="submenu-list">
            <mat-expansion-panel *ngFor="let series of allSeriesList;let j= index" (click)="getMatchList(series,j)" (opened)="panelOpenState1 = true" (closed)="panelOpenState1 = false">
              <mat-expansion-panel-header >
                <a> <span>{{series.name}}</span></a>
              </mat-expansion-panel-header>
            <mat-accordion>
              <ul class="submenu-list date-list">
                <mat-expansion-panel [ngClass]="{'display-list': isShowSubMenu}" *ngFor="let matchData of matchList[j] | keyvalue;let l = index;" (click)="getDateData(matchData?.value,matchData?.key)" (opened)="panelOpenState2 = true" (closed)="panelOpenState2 = false">
                  <mat-expansion-panel-header (click)="addClass()">
                    <a class="sub-menu-item"> {{matchData?.key }} </a>
                  </mat-expansion-panel-header>
                  <mat-accordion >
                    <ul class="submenu-list" *ngIf="matchData?.key == currentData">
                      <mat-expansion-panel   *ngFor="let match of dateWiseData;let k= index" (click)="matchDetail(match)" (opened)="panelOpenState3 = true" (closed)="panelOpenState3 = false">
                        <mat-expansion-panel-header >
                          <a class="sub-menu-item">  {{match.match_name}} </a>
                        </mat-expansion-panel-header>
                      </mat-expansion-panel>
                    </ul>
                  </mat-accordion>
                </mat-expansion-panel>
              </ul>
            </mat-accordion>
            </mat-expansion-panel>
          </ul>
        </mat-accordion>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>